import { render, staticRenderFns } from "./JobReturns.vue?vue&type=template&id=0cea0d6c&"
import script from "./JobReturns.vue?vue&type=script&lang=js&"
export * from "./JobReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports